import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitPayload} from '../types/commit-types'

export const commitFragmentRoute = commitsAppBuilder.createQueryRouteConfig('commitFragmentRoute', {
  path: '/_view_fragments/Voltron::CommitFragmentsController/show/:owner/:repo/:name/repo_layout',
  queries: [mainQuery<CommitPayload>()],
})
